import React from 'react'

function NowLiveList() {
  return <>NowLiveList</>
}

export default NowLiveList
